import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from 'react-router-dom';
import { ArcaProvider } from './context/ArcaContext.context';
import { WithI18n } from './context/translations/TranslationsContext.context';
import { PostHogWrapper } from './providers/PostHogProvider';
import AvisoNavegador from './components/AvisoNavegador';
import { installDemoAccountInterceptor } from './utils/demoAccountInterceptor';
import {
	admiteLoQueTailwindNecesita,
	haDecididoSeguir,
	recordarQueSigue
} from './navegadorSoportado';
import AbrirConSesion from './movil/AbrirConSesion';
import ActualizacionObligatoria from './movil/ActualizacionObligatoria';
import BloqueoBiometrico from './movil/BloqueoBiometrico';
import OfertaBiometria from './movil/OfertaBiometria';
import { instalarApp } from './movil/instalarApp';

// App móvil: botón atrás, cabeceras, enlaces, teclado, zoom… En la web no hace nada.
instalarApp();

// Cuenta demo de los revisores: el aviso de operación bloqueada sale de UN solo sitio
// (comparsa docs/CUENTAS_DEMO.md). Para los clientes reales no cambia nada.
installDemoAccountInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

/**
 * Qué se pinta: la aplicación, o el aviso de navegador.
 *
 * 🔴 El aviso va DENTRO de los proveedores y no antes de React, aunque la tarea lo pedía «antes
 * de pintar React». El motivo: necesita el diccionario de traducciones y PostHog, y los dos son
 * React. Lo que de verdad importaba —que nadie llegue a ver la aplicación sin estilos— se
 * cumple igual, porque si el navegador no llega, `<App />` no se monta.
 *
 * La decisión de seguir se relee en cada render: al pulsar el botón se guarda y se vuelve a
 * pintar, esta vez con la aplicación.
 */
const Raiz = () => {
	const [sigueDeTodosModos, setSigueDeTodosModos] = React.useState(haDecididoSeguir);

	if (!admiteLoQueTailwindNecesita() && !sigueDeTodosModos) {
		return (
			<AvisoNavegador
				onContinuar={() => {
					recordarQueSigue();
					setSigueDeTodosModos(true);
				}}
			/>
		);
	}

	return (
		<Router>
			{/* En la app, abrir con la sesión viva lleva al panel y no al login; en la web nada. */}
			<AbrirConSesion />
			<App />
			{/* «¿Abrir Arca con Face ID?» tras el primer login en la app; en la web no pinta nada. */}
			<OfertaBiometria />
		</Router>
	);
};

root.render(
	<PostHogWrapper>
		<ArcaProvider>
			<WithI18n>
				{/* En la app, con un binario por debajo del mínimo, en lugar de todo esto (login y
				    Face ID incluidos) se pinta «Actualiza la app». En la web pinta lo de dentro. */}
				<ActualizacionObligatoria>
					<Raiz />
					{/* Solo en la app y solo si el usuario lo activó; en la web no pinta nada. */}
					<BloqueoBiometrico />
				</ActualizacionObligatoria>
			</WithI18n>
		</ArcaProvider>
	</PostHogWrapper>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
